import HttpHelper from "./helper";

export const teamOfTheCompetitionGameEndpoints = {
  postAnswer: (inputData) =>
    HttpHelper.baseAxios
      .post(`/world-cup-team/submit`, inputData)
      .then((res) => res.data)
      .catch((err) => err),
};
